<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>Lọc thông tin</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <label>Đơn vị</label>
          <treeselect
            v-on:select="formatDonVis"
            :options="treeOptions"
            value-format="id"
            v-model="value"
            :clearable="true"
            :searchable="true"
            :show-count="true"
            :default-expand-level="1"
            :normalizer="normalizer"
            placeholder="Chọn đơn vị"
            @input="$emit('update:donViFilter', value)"
          />
        </b-col>
        <b-col cols="12" md="6" class="mb-md-0 mb-2">
          <label>Trạng thái</label>
          <v-select
            v-model="status"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="lockOptions"
            :reduce="(val) => val.value"
            :clearable="false"
            @input="$emit('update:status', status)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    Treeselect,
  },

  props: {
    donViFilter: {
      type: String,
      default: null,
    },
    treeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      value: null,
      status: true,
    };
  },
  watch: {
    treeOptions() {
      // console.log(this.treeOptions[0]);
      // this.value = this.treeOptions[0].id;
    },
  },

  methods: {
    formatDonVis(node, instanceId) {},
    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
  },
  setup(props, { emit }) {
    const lockOptions = [
      {
        label: "Đang hoạt động",
        value: true,
      },
      {
        label: "Đã bị khóa",
        value: false,
      },
    ];

    return {
      lockOptions,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
